import React, { ReactNode } from 'react';
import { useParams } from 'next/navigation';
import { Index } from 'react-instantsearch-hooks';
import {
  productsIndex_AU,
  productsIndex_NZ,
  productsQuerySuggestionsIndex_AU,
  productsQuerySuggestionsIndex_NZ,
} from '@/constants/algolia';

interface Props {
  type: 'products' | 'query-suggestions';
}

export const useLocalizedIndex = ({ type }: Props) => {
  const { locale } = useParams();
  // Normalize locale to 'au' or 'nz'
  const store = (typeof locale === 'string' ? locale : Array.isArray(locale) ? locale[0] : 'au').toLowerCase();

  const indexes = {
    products: {
      au: productsIndex_AU,
      nz: productsIndex_NZ,
    },
    'query-suggestions': {
      au: productsQuerySuggestionsIndex_AU,
      nz: productsQuerySuggestionsIndex_NZ,
    },
  };

  // Fallback to 'au' if locale is not 'au' or 'nz'
  const indexName = indexes[type][store === 'nz' ? 'nz' : 'au'];

  return { indexName };
};

const LocalizedIndex = ({ children, type }: React.PropsWithChildren<Props>) => {
  const { indexName } = useLocalizedIndex({ type });
  
  // Using type casting to fix the JSX element type error
  const IndexComponent = Index as any;

  return <IndexComponent indexName={indexName}>{children}</IndexComponent>;
};

export default LocalizedIndex;
